module.exports = __webpack_public_path__ + "static/img/02.20694b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/02/02.jpg
// module id = mmTw
// module chunks = 0